<template>
  <j-form-container :disabled="disabled">
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="6">
            <a-form-item label="税号" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['taxCode',validatorRules.taxCode]" placeholder="请输入税号"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="法人" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['contactName']" placeholder="请输入法人"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="开户行" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['bankName',validatorRules.bankName]" placeholder="请输入开户行"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="开户行账户" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['bankAccount',validatorRules.bankAccount]" placeholder="请输入开户行账户"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="委托代理人" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['agentName']" placeholder="请输入委托代理人"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="代理人身份证" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['agentId']" placeholder="请输入代理人身份证"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="住所" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['address',validatorRules.address]" placeholder="请输入住所"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="养殖所在地" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['breedAddress']" placeholder="请输入养殖所在地"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="邮编" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['postCode',validatorRules.postCode]" placeholder="请输入邮编"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item :label="$t('label.telephone')" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input v-decorator="['telephone',validatorRules.telephone]" :placeholder="$t('label.pleaseEnterTelephone')"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="传真" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['fax']" placeholder="请输入传真"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="邮箱" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['email',validatorRules.email]" placeholder="请输入邮箱"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item :label="$t('label.remarks')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['remarks']" :placeholder="$t('label.pleaseEnterANote')"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item v-has="'signInfoType'" label="合同方" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag disabled type="list" v-decorator="['signInfoType']" :trigger-change="true" dictCode="htf" placeholder="请选择合同方"/>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
  </j-form-container>
</template>
<script>
  import pick from 'lodash.pick'
  import { getAction } from '@/api/manage'
  import { validateDuplicateValue } from '@/utils/util'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import JDictSelectTag from "@/components/dict/JDictSelectTag"

  export default {
    name: 'EfsMdContractSignInfoForm',
    components: {
      JFormContainer,
      JDictSelectTag,
    },
    props:{
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        form: this.$form.createForm(this),
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 6 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        labelCol2: {
          xs: { span: 24 },
          sm: { span: 3 },
        },
        wrapperCol2: {
          xs: { span: 24 },
          sm: { span: 20 },
        },
        validatorRules: {
            taxCode: {
                rules: [
                    { required: true, message: '请输入税号!'},
                ]
            },
            bankName: {
                rules: [
                    { required: true, message: '请输入开户行!'},
                ]
            },
            bankAccount: {
                rules: [
                    { required: true, message: '请输入开户行账号!'},
                ]
            },
            address: {
                rules: [
                    { required: true, message: '请输入住所!'},
                ]
            },
            postCode: {
                rules: [
                    { required: true, message: '请输入邮编!'},
                ]
            },
            telephone: {
                rules: [
                    { required: true, message: '请输入电话!'},
                ]
            },
            email: {
                rules: [
                    { required: true, message: '请输入邮箱!'},
                ]
            },
        },
        confirmLoading: false,
      }
    },
    methods:{
      initFormData(url,id){
        this.clearFormData()
        if(!id){
          this.edit({})
        }else{
          getAction(url,{id:id}).then(res=>{
            if(res.success){
              let records = res.result
              if(records && records.length>0){
                this.edit(records[0])
              }
            }
          })
        }
      },
      edit(record){
        this.model = Object.assign({}, record)
        console.log("EfsMdContractSignInfoForm-edit",this.model);
        let fieldval = pick(this.model,'signInfoType','taxCode','contactName','bankName','bankAccount','agentName','agentId','address','breedAddress','postCode','telephone','fax','email','remarks')
        this.$nextTick(() => {
          this.form.setFieldsValue(fieldval)
        })
      },
      getFormData(){
        let formdata_arr = []
        this.form.validateFields((err, values) => {
          if (!err) {
            let formdata = Object.assign(this.model, values)
            let isNullObj = true
            Object.keys(formdata).forEach(key=>{
              if(formdata[key]){
                isNullObj = false
              }
            })
            if(!isNullObj){
              formdata_arr.push(formdata)
            }
          }else{
            this.$emit("validateError","合同甲方乙方信息表单校验未通过");
          }
        })
        console.log("合同甲方乙方信息表单数据集",formdata_arr);
        return formdata_arr;
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'signInfoType','taxCode','contactName','bankName','bankAccount','agentName','agentId','address','breedAddress','postCode','telephone','fax','email','remarks'))
      },
      clearFormData(){
        this.form.resetFields()
        this.model={}
      },
    }
  }
</script>
